import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { RegisterModalProvider } from "@/context/RegisterModalContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SmoothScroll } from "@/components/SmoothScroll";
import { RegisterModal } from "@/components/RegisterModal";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { ScrollProgress } from "@/components/ScrollProgress";
import { BackToTop } from "@/components/BackToTop";
import { CookieConsent } from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import TaxForms from "@/pages/TaxForms";
// import CoverArtGenerator from "@/pages/CoverArtGenerator"; // Generador de portadas oculto a pedido del usuario
import RequestStatus from "@/pages/RequestStatus";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancelled from "@/pages/PaymentCancelled";
import SmartlinkPage from "@/pages/SmartlinkPage";
import CreateSmartlink from "@/pages/CreateSmartlink";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <SmoothScroll>
        <RegisterModalProvider>
          <BrowserRouter>
            <AuthProvider>
              <div className="App bg-[#0A0A0A] min-h-screen overflow-x-hidden">
                <div className="grain-overlay" aria-hidden="true" />
                <ScrollProgress />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/legal/:slug" element={<Legal />} />
                  <Route path="/formularios-fiscales" element={<TaxForms />} />
                  {/* Generador de portadas oculto a pedido del usuario: <Route path="/generador-portadas" element={<CoverArtGenerator />} /> */}
                  <Route path="/consultar-solicitud" element={<RequestStatus />} />
                  <Route path="/pago/exito" element={<PaymentSuccess />} />
                  <Route path="/pago/cancelado" element={<PaymentCancelled />} />
                  <Route path="/smartlink/:slug" element={<SmartlinkPage />} />
                  <Route path="/crear-smartlink" element={<CreateSmartlink />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
                <RegisterModal />
                <FloatingWhatsApp />
                <BackToTop />
                <CookieConsent />
                <Toaster position="top-center" richColors />
              </div>
            </AuthProvider>
          </BrowserRouter>
        </RegisterModalProvider>
      </SmoothScroll>
    </LanguageProvider>
  );
}

export default App;
